<script lang="ts">
  import SectionVirementDeliveryDetail from '@/generated/sections/SectionVirementDeliveryDetail.vue';
  import { TransactionTypes, TransactionStatuts } from '@/generated/classes/Transaction';
  import { ColumnFilter, ListChoix } from '@/extend/classes/ListData';
  import Transaction from '@/extend/classes/Transaction';
  import Delivery, { DeliveryTypes } from '@/generated/classes/Delivery';
  import { defineComponent, type PropType } from "vue";
  import Button from '@/framework/base/classes/Button';

  export default defineComponent({
    components: {},
    extends: SectionVirementDeliveryDetail,
    props: {
      delivery: {
        type: Object as PropType<Delivery>,
        required: true
      }
    },
    data() {
      const removedList: Transaction[] = [];
      const buttons: Button[] = [];
      return {
        removedList,
        buttons,
        rebuildProgress: false,
        lastDeliveryId: 0
      };
    },
    computed: {
      headers() {
        if (this.lastDeliveryId != this.delivery.id) {
          this.setLastDeliveryId();
          this.activeFilters = [];
          this.pageNumber = 1;
          this.resetActiveFilters();
          this.reloadTable();
        }
        return [
          { text: "Destinataire", value: 'ownerLabel', cellClass: '', sortable: true },
          { text: "Référence", value: 'reference', cellClass: '', sortable: true },
          { text: "Montant", value: 'amount', cellClass: '', sortable: true },
          { text: 'Action(s)', width: '20%', value: 'action', cellClass: 'iterate-cell-class iterate-cell-action', sortable: false },
        ];
      },
      pageLimit(): number {
        return -1;
      },
      deliveryId(): number {
        return this.delivery.id;
      },
      canAdd(): boolean {
        return false;
      },
      extraButtons(): Button[] {
        const rebuild = new Button();
        rebuild.label = 'Générer XML';
        rebuild.show = true;
        rebuild.disabled = this.rebuildProgress || this.removedList.length == 0;
        rebuild.outlined = true;
        rebuild.loading = false;
        rebuild.callback = () => this.rebuild();
        return [rebuild];
      }
    },
    methods: {
      selectItem(event: any, row: any): void {        
        if (event != undefined) {
          event.stopPropagation();
        }
      },
      setLastDeliveryId() {
        this.removedList = [];
        this.lastDeliveryId = this.delivery.id;
      },
      canUpdate(transaction: Transaction): boolean {
        return false;
      },
      defaultFilter(): void {
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "type";
          columnFilter.staticFilter = true;
          const choix = new ListChoix();
          choix.value = TransactionTypes.VIREMENT_EMIS;
          columnFilter.filters.push(choix);
          this.activeFilters.push(columnFilter);
        }
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "deliveryId";
          columnFilter.staticFilter = true;
          const choix = new ListChoix();
          choix.value = this.deliveryId;
          columnFilter.filters.push(choix);
          this.activeFilters.push(columnFilter);
        }
      },
      getActionColor(transaction: Transaction): string {
        const index = this.removedList.indexOf(transaction);
        if (index >= 0) {
          return '#F40F02';
        } else {
          return '#1D6F42';
        }
      },
      mdiAction(transaction: Transaction): string {
        if (transaction.bankId > 0) {
          return 'fas fa-landmark';
        } else {
          const index = this.removedList.indexOf(transaction);
          if (index >= 0) {
            return 'fas fa-x';
          } else {
            return 'fas fa-minus';
          }
        }
      },
      hasAction(transaction: Transaction): boolean {
        return transaction.deliveryId > 0;
      },
      execAction(transaction: Transaction): void {
        if (transaction.bankId == 0) {
          const index = this.removedList.indexOf(transaction);
          if (index >= 0) {
            this.removedList.splice(index, 1);
          } else {
            this.removedList.push(transaction);
          }
        }
      },
      rebuild(): Promise<void> {
        return new Promise((resolve) => {
          this.rebuildProgress = true;
          Delivery.rebuildVirement(this.removedList).then(() => {
            this.rebuildProgress = false;
            resolve();
          });
        });
      }
    }
  })

</script>
